<template>
  <div>
    <px-view-header title="Tipos de uso"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-listagem-tipos-uso-header :on-click-refresh="onClickRefresh"
                              :on-change-filter="onChangeFilter" />
    <px-lista-tipos-uso :tipos-uso="tiposUso"
                    :loading="loading"
                    :on-change-options="onChangeOptions"
                    :options-list="optionsList"
                    :footer-options="footerOptions"
                    @remove="onRemove" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-tipos-uso/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import TiposUsoService from './tipos-uso-service';
import ListaTiposUso from './ListaTiposUso.vue';
import ListagemTiposUsoHeader from './ListagemTiposUsoHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Produtos' },
        { text: 'Tipos de uso' },
      ],
      tiposUso: {
        content: [],
        total: 0,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemTiposUso', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemTiposUso', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getTiposUso();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getTiposUso();
    },
    onClickRefresh() {
      this.getTiposUso();
    },
    onRemove(item) {
      this.loading = true;
      TiposUsoService.remover(item.id)
        .then(() => {
          this.$toast('Tipo de uso removido com sucesso', { color: 'success' });
          this.getTiposUso();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getTiposUso() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return TiposUsoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.tiposUso = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxListaTiposUso: ListaTiposUso,
    pxListagemTiposUsoHeader: ListagemTiposUsoHeader,
  },
};

</script>
